import React from "react";

const GoogleMapReact = ({ children, ...rest }) => {
  return (
    <React.Fragment>
      <pre> {JSON.stringify(rest, { space: "" })}</pre>
      <pre>{JSON.stringify(children)}</pre>

      {/* <div>
        {Object.entries(rest).map((_) => {
          return (
            <span key={_[0]}>
              {_[0]}&nbsp;=&nbsp;{_[1]}
            </span>
          );
        })}
      </div> */}
    </React.Fragment>
  );
};

export default GoogleMapReact;
